import React from 'react';
import FlikLogo from '../../components/Logo/FlikLogo';
import './AuthPromoPanel.css';

/**
 * Dark "ladera" column shown on the left of the auth screens.
 *
 * Variants:
 *  - "login" / "register": community pitch, bullets and the snow slope.
 *  - "activate": "one last step" message + a 3-step vertical stepper (no snow
 *    slope, matching the v3 "02B Activar" screen).
 */
function AuthPromoPanel({ variant = 'login', showStats = false }) {
  if (variant === 'activate') {
    return (
      <aside className="AuthPromo AuthPromo--activate">
        <div className="AuthPromo-grain" aria-hidden="true" />

        <header className="AuthPromo-top">
          <FlikLogo height={24} />
        </header>

        <div className="AuthPromo-body">
          <span className="AuthPromo-eyebrow AuthPromo-eyebrow--tag">
            Verificación
          </span>
          <h2 className="AuthPromo-title AuthPromo-title--sm">
            Último paso
            <br />
            antes de
            <br />
            la cima
          </h2>
        </div>

        <ol className="AuthPromo-steps">
          <li className="AuthPromo-step AuthPromo-step--done">
            <span className="AuthPromo-stepMark" aria-hidden="true">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="butt">
                <path d="M4 12 L10 18 L20 6" />
              </svg>
            </span>
            <span>01 · Datos de la cuenta</span>
          </li>
          <li className="AuthPromo-step AuthPromo-step--current">
            <span className="AuthPromo-stepMark" aria-hidden="true">
              <span className="AuthPromo-stepDot" />
            </span>
            <span>02 · Código por correo</span>
          </li>
          <li className="AuthPromo-step">
            <span className="AuthPromo-stepMark" aria-hidden="true" />
            <span>03 · Tu primera ruta</span>
          </li>
        </ol>
      </aside>
    );
  }

  return (
    <aside className={`AuthPromo AuthPromo--login`}>
      <div className="AuthPromo-grain" aria-hidden="true" />

      <header className="AuthPromo-top">
        <FlikLogo height={24} />
      </header>

        <div className="AuthPromo-body">
          <span className="AuthPromo-eyebrow AuthPromo-eyebrow--tag">
            Rutas · Cimas · Barrancos
          </span>
          <h2 className="AuthPromo-title">
            La montaña,
            <br /> a un flik.
          </h2>
          <p className="AuthPromo-lead">
            Rutas cartografiadas por la comunidad, tracks GPX y fichas MIDE.
          </p>
          <ul className="AuthPromo-bullets">
            <li>Guarda favoritos y planifica salidas.</li>
            <li>Consigue insignias por cada reto.</li>
            <li>Gratis para siempre, sin tarjeta.</li>
          </ul>
          { showStats && (
                      <dl className="AuthPromo-stats">
            <div className="AuthPromo-stat">
              <dt>1.284</dt>
              <dd>Rutas</dd>
            </div>
            <div className="AuthPromo-stat">
              <dt>63</dt>
              <dd>Barrancos</dd>
            </div>
            <div className="AuthPromo-stat">
              <dt>9.2k</dt>
              <dd>Exploradores</dd>
            </div>
          </dl>
          )}

        </div>

        <footer className="AuthPromo-footer">
          Nos vemos en la montaña
        </footer>

      <span className="AuthPromo-est">Est. 2026 Valencia</span>

      <div className="AuthPromo-mountains" aria-hidden="true">
        <span className="AuthPromo-mountain AuthPromo-mountain--back" />
        <span className="AuthPromo-mountain AuthPromo-mountain--front" />
      </div>
    </aside>
  );
}

export default AuthPromoPanel;
